import { intl } from '@/intl'

export const getDateText = () => intl.translate({ id: 'global.date' })
